"use strict";

import {Dispatcher} from "vwa/flux";

const dispatcher = new Dispatcher();
window.dispatcher = dispatcher;

export default dispatcher;


// WEBPACK FOOTER //
// ./src/dispatcher.js